export default {
  /* Global */
  documentation: 'Documentation',
  copied: 'Successfully Copied.',
  copyFailed: 'Copy failed.',
  login: 'Log in',
  logout: 'Log out',
  privacyPolicyConfirmation:
    "Please confirm you've read and understood our Privacy Policy on data use and protection.",

  /* MainNavigation */
  products: 'Products',
  governance: 'Governance',
  organizations: 'Organizations',
  organization: 'Organization',
  reports: 'Reports',
  compute: 'Compute',
  myProducts: 'My products',
  productSpecification: 'Product Specification',
  order: 'Order',
  freeTrial: 'Free Trial',
  safescarf: 'SafeSCARF',
  myInstance: 'My instance',
  caas: 'CaaS',
  myClusters: 'My Clusters',
  monitoring: 'Monitoring',
  baremetal: 'BareMetal',
  myDashboards: 'My dashboards',
  helpFeedback: 'Support & Feedback',

  /* SidenNavigation */
  overview: 'Overview',
  users: 'Users',
  businessUnits: 'Business Units',
  projects: 'Projects',
  monitoringDashboards: 'Monitoring Dashboards',
  tenants: 'Tenants',
  hypervisors: 'Hypervisors',
  juiceGroups: 'Juice Groups',
  caasCluster: 'Caas Clusters',
  tdiConnectPortal: 'TDI Connect Portal',
  profile: 'Profile',
  notifications: 'Notifications',
  security: 'Security',

  /* Reports Page */
  tenantsReportTableMessage:
    'No tenant reports available. Please select a cloud from the dropdown.',
  hypervisorsTableMessage: 'No hypervisors available. Please select a cloud from the dropdown.',

  /* Feedback Page */
  feedbackSuccess: 'Feedback sent successfully!',
  caasupgradeSuccess: 'Upgrade initiated successfully!',
  attachmentSizeError:
    'Total file size exceeds 2MB limit. Please reduce the number or size of files.',
  feedbackTitle: 'Support & Feedback',
  feedbackDescription:
    'We value your feedback. Please share your thoughts, suggestions, or report any issues.',

  /* Table */
  emptyTable: 'No records to display.',

  /* Delete Modal */
  deleteMessage1: 'Are you sure you want to delete this {name}?',
  deleteMessage2: 'Type in the following to confirm: ',

  /* Cookie Banner */
  cookieBannerTitle: 'Cookie Usage',
  cookieBannerCheckboxMessage1:
    'By checking this box, you confirm that you have read & understood our ',
  cookieBannerCheckboxMessage2:
    ', which explains how we collect, use, and protect your personal data.',

  /* Home Page */
  title: 'TDI Connect',
  iaasDescription:
    'Empower IT & Telco with Cloud Services for Scalable, Efficient Operations Across Europe',
  computeTitle: 'Compute',
  computeSubheader: 'Scalable Compute for Any Workload',
  computeDescription:
    'Effortlessly deploy and scale high-performance compute resources in the cloud. Designed for demanding workloads like AI, data processing, and simulation — with fast provisioning, flexible pricing, and global availability.',
  computeButtonText: 'Read the Compute specs',
  caasTitle: 'CaaS',
  caasSubheader: 'Container as a Service',
  caasDescription:
    'Offers a managed environment for deploying and scaling containerized applications using Kubernetes clusters via API. Supports CaaS on OpenStack (VM-based clusters) or BareMetal (dedicated physical server clusters).',
  caasButtonText: 'Read the CaaS specs',
  safescarfTitle: 'SafeSCARF',
  safescarfDescription:
    'SafeSCARF offers scanning tools and vulnerability management for non-cloud environments, supporting multiple report formats with an easy-to-use interface and flexible free trials.',
  safescarfSubheader: 'Security single pane of glass',
  safescarfButtonText: 'Read the SafeSCARF specs',
  monitoringTitle: 'Monitoring',
  monitoringSubheader: 'Real-Time Insights with Grafana Dashboards',
  monitoringDescription:
    'Visualize system health and performance at a glance. Our integrated Grafana dashboards deliver real-time metrics, customizable alerts, and deep observability across your infrastructure.',
  monitoringButtonText: 'Read the Monitoring specs',
  marketPlaceText: 'Our Marketplace',
  /* api key */
  apiKeyGenerated: 'API key successfully generated',
  apiKeyGenerationErr: 'API key generation failed',
  apiKeyCopy1: 'Please copy this API key and store it in a safe place.',
  apiKeyCopy2: 'You will not be able to see it again.',

  /* users */
  userActivated: 'User was successfully activated.',
  userPasswordChanged: 'Password was successfully changed.',
  userPasswordMismatch: 'Passwords do not match.',
  userPasswordResetEmail: 'Your password reset email has been sent.',
  userPasswordReset: 'User password was successfully saved. Now you can log in.',
  cloudPasswordUpdate: 'Cloud password was successfully updated.',
  userCreation: 'User was successfully created.',
  userDeleted: 'User was successfully deleted.',
  userUpdated: 'User was successfully updated.',
  userDeletePermissionErr: "You don't have a permission to delete this user.",
  userEditPermissionErr: "You don't have a permission to edit this user.",
  userUnassignment1: 'This user is assigned to the following products:',
  userUnassignment2: 'By proceeding, the user will be unassigned from these products.',
  incorrectToken: 'Incorrect token',
  userActivationErr: 'User activation failed',
  userCreationPermissionErr: "You don't have the permission to create a new user.",

  /* business units */
  businessUnitCreation: 'Business unit was successfully created.',
  businessUnitUpdated: 'Business unit was successfully updated.',
  businessUnitDeleted: 'Business unit was successfully deleted.',
  businessUnitEditPermissionErr: "You don't have the permission to edit this business unit.",
  businessUnitDeletePermissionErr: "You don't have the permission to delete this business unit.",
  businessUnitCreatePermissionErr: "You don't have the permission to create new business unit.",

  /* organizations */
  organizationCreation: 'Organization was successfully created.',
  organizationUpdated: 'Organization was successfully updated.',
  organizationCreationPermissionErr: "You don't have the permission to create a new organization.",
  editOrganizationDisabled: "You don't have the permission to edit this organization.",

  /* osprojects */
  createOsProjectFulfilled:
    'We are preparing your product in the data center. This operation will take a few minutes. You will be notified when the product is ready, and the service status will be shown as active. You can access all your active products (OpenStack projects) with one password per data center. This data center password is sent to you by e-mail when you create your first product (OpenStack project) in a respective data center. In case you did not receive an e-mail with a password, or you forgot your data center password, you can easily restore it in the portal (under Settings) – or contact our support team.',
  osProjectNameDuplicate: 'This project name is already in use in the selected cloud',
  osProjectDeleted: 'Deletion succesfully started',
  osProjectSetDeleted: 'Succesfully Deleted OsProject',
  osProjectPatchFailed: 'Unable to set OsProject to deleted',
  osProjectDeleteDisabled:
    "You don't have rights to set this OsProject to deleted. Please contact an admin user.",
  osProjectDeleteDisabledCreatedFromJuice:
    'This osproject was created from juice and cannot be deleted.',
  osProjectsDeleteMessage: 'If you delete this Os Project, it will also be deleted from OpenStack.',

  /* projects */
  projectCreation: 'Project was successfully created.',
  projectDeleted: 'Project was successfully deleted.',
  projectEdit: 'Project was successfully updated.',
  noUsageData: 'There is no usage data.',
  projectCreationPermissionErr: "You don't have the permission to create a new project.",
  adminOrgActionDisabled: 'Not allowed in admin-org',
  editProjectDisabled: "You don't have the permission to edit this project.",
  projectDeleteDisabled: 'Project cannot be deleted.',
  projectDeleteDisabledHasProducts: 'Cannot delete project with existing products.',

  /* products */
  productForecasts: 'Product {name} forecasts',
  productCreationPermissionErr: "You don't have the permission to create a new product.",
  evaluationProductCreationDisabled: "You can't create new evaluation product.",
  productCreation: 'Product was successfully created.',
  productUpdated: 'Product was successfully updated.',
  productDeleted: 'Product was successfully deleted.',
  productDeleteDisabled: "You don't have rights to delete this product. Please contact admin user",
  productDeleteUndoable: "This type of product can't  be deleted.",
  productDeleteDisabledOsProjects: 'There are existing OsProjects in this product',
  productDeleteDisabledCaasClusters: 'There are existing CaaS Clusters in this product',
  productDeleteDisabledCaasBm: 'Product with type caasonbaremetal is not deletable',
  editProductDisabled: "You don't have the permission to edit this product.",
  productDeleteMessage:
    'If you delete this product, the juice group associated with it will also be deleted.',

  /* Compute Order Text for Project and Resource Allocation */
  projectName: 'A user-friendly name identifying the OS Project.',
  projectDescription:
    'The initiative or activity of your organization. Projects can be created only by Admins.',
  productDescription:
    'Child of a Project that requires you to instantiate cloud resources. Products can be created only by Admins.',
  dataCenterDescription:
    'TDI-operated data centers in Europe, compliant with DT standards and organized in a geo-redundant location concept.',
  virtualCPUsAndMemory:
    'Amounts to be allocated to your OpenStack project. The vCPUs are offered with a standard processing performance. In case you require high performance processing, please reach out to our support team.',

  /* forecasts */
  forecastsNotFound:
    'There is no information in forecast DB for this Juice Group, you cannot create virtual cloud for this project.',
  forecastsApplySuccess: 'Forecast(s) are successfully applied',
  forecastsApplyFailure: 'Forecast(s) applying failed',

  /* juiceGroup  info */
  editJuiceGroupInfo: 'Edit JuiceGroup info',
  geoRedundancySet: 'Geo redundancy was successfully set',
  serviceAdded: 'External service was successfully added',
  serviceRemoved: 'External service was successfully removed',

  /* contact info */
  contactAdded: 'Contact information was successfully added',
  contactEdited: 'Contact information was successfully updated',
  contactRemoved: 'Contact information was successfully removed',
  contactCreateDisabled: "You don't have rights to create contact",
  contactEditDisabled: "You don't have rights to edit contact",
  contactDeleteDisabled: "You don't have rights to delete contact",

  /* safescarf */
  safescarfStatusLabel: 'The progress of your SafeSCARF instance deployment is:',
  safescarfMachineAccountCreated:
    'Your new Machine Account has been created with the following username:',

  safescarfProductTypeCreated: 'Product type was successfully created.',
  safescarfProductTypeUpdated: 'Product type was successfully updated.',
  createProductTypeDisabled: 'You are not entitled to create a new product type.',
  editProductTypeDisabled: 'You are not entitled to edit this product type.',

  safescarfProductTypeMemberUpdated: 'Product type member was successfully updated.',
  editProductTypeMemberDisabled: 'You are not entitled to edit this product type member.',
  editProductTypeMemberNotificationTitle:
    'Permissions granted at the product type level are inherited by all products within that product type.',
  editProductTypeMemberNotificationText:
    'For example, users with Maintainer permission have maintainer permissions in all products of this product type.',

  safescarfProductCreated: 'Product was successfully created.',
  safescarfProductUpdated: 'Product was successfully updated.',
  safescarfProductDeleted: 'Product was successfully deleted.',
  safescarfProductDeleteDisabled: "You don't have rights to delete this product.",
  createProductDisabled: 'You are not entitled to create a new product.',
  editSafescarfProductDisabled: 'You are not entitled to edit this product.',

  safescarfProductMemberUpdated: 'Product member was successfully updated.',
  editProductMemberDisabled: 'You are not entitled to edit this product member.',

  /* Notification Messages */
  defaultErrorMessage: 'Something went wrong',
  duplicateContactValidation: 'A contact with this email and role already exists',

  /* Errors */
  ERR_BAD_REQUEST: 'Bad request',
  ERR_NOT_FOUND: 'Not found',
  ERR_DUPLICATION: 'Duplication error',
  ERR_INPUT_VALIDATION: 'Input validation failure',
  ERR_UNAUTHORIZED: 'Not authorized',
  ERR_USER_DELETION_NOT_ENTITLED: "User doesn't have rights to delete that user role",
  ERR_FORBIDDEN: 'Forbidden',
  ERR_VERIFICATION_TOKEN: 'Verification token mismatch or user not found',
  ERR_INTERNAL_SERVER_ERROR: 'Internal Server Error',
  ERR_NAME_INVALID:
    'Name must contain only lowercase letters, numbers, and hyphens (e.g., my-project)',
  ERR_ORG_NAME_INVALID:
    'Organization name must contain only lowercase letters, numbers, and hyphens (e.g., my-org)',
  ERR_PASSWORD_INVALID:
    'Your password should have at least, 10 characters, 1 uppercase, 1 lowercase, 1 digit and 1 special character (no space).',
  ERR_PASSWORD_DUPLICATE: 'You cannot re-use the current password',
  ERR_EMAIL_FAILED: 'User creation failed',
  ERR_MARKETPLACE_ITEM_NOT_ENABLED: 'Marketplace item not enabled',
  ERR_EXISTING_PRODUCTS: 'Cannot proceed because of existing products',
  ERR_EXISTING_TENANT: 'Cannot proceed because of existing tenants',
  ERR_ITEM_ALREADY_ACTIVATED: 'The selected marketplace item is already active',
  ERR_JUICEGROUP_INVALID_LENGTH: 'The Juice Group name must be between 3 and 64 characters',
  ERR_JUICEGROUP_INVALID: 'The Juice Group Name is invalid',
  ERR_SCIM_UNSUPPORTED_SYNTAX: 'Unsupported SCIM filter syntax',
  ERR_MARKETPLACE_ITEM_NOT_ALLOWED: 'Marketplace item is not allowed for this organization',
  ERR_ADMIN_EXISTS: 'An admin user already exists for this organization',
  ERR_UPSTREAM_SERVICE_ERROR: 'An upstream service encountered an error. Please try again later',
  400: 'Bad request',
  401: 'Not authorized',
  403: 'Forbidden',
  404: 'Not found',
  409: 'Duplication error',
  500: 'Something went wrong on our end. Please try again later or report this issue using the feedback section.',
};
